import { render, staticRenderFns } from "./ModalDisputes.vue?vue&type=template&id=6a2dc870"
import script from "./ModalDisputes.vue?vue&type=script&lang=js"
export * from "./ModalDisputes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports